// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attachedFilesBlock__uRfMZ {
  width: 100%;
}

.attachedFilesTitle__T_OfJ {
  font-size: 11px;
  line-height: 13px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
}

.attachedFiles__iwSO2 {
  width: 100%;
  margin-top: 10px;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  border-radius: 2px;
  background: var(--tables-secondary-row-sub-title-surface);
}

.fileItem__c21kh {
  width: 100%;
  max-width: 346px;
  text-decoration: none;
  display: grid;
  grid-template-columns: 42px 1fr;
  align-items: center;
  column-gap: 5px;
  padding: 5px;
  border-radius: 4px;
  border: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  border-radius: 4px;
  cursor: pointer;
}

.fileItemPicture__Osspv {
  width: 42px;
  height: 29px;
}

.image__bIQH5 {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 2px;
}

.name__Mccdm {
  font-size: 11px;
  line-height: 12px;
  color: var(--tables-primary-row-text-main);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.extra__u_RWd {
  font-size: 11px;
  line-height: 12px;
  color: var(--tables-primary-row-text-additional);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./../src/components/common/FilesFieldComponent/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,yCAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,yDAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,+BAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,kDAAA;EACA,qDAAA;EACA,kBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,gDAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAzEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.attachedFilesBlock {\n  width: 100%;\n}\n\n.attachedFilesTitle {\n  font-size: 11px;\n  line-height: 13px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n}\n\n.attachedFiles {\n  width: 100%;\n  margin-top: 10px;\n  padding: 15px 25px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  border-radius: 2px;\n  background: var(--tables-secondary-row-sub-title-surface);\n}\n\n.fileItem {\n  width: 100%;\n  max-width: 346px;\n  text-decoration: none;\n  display: grid;\n  grid-template-columns: 42px 1fr;\n  align-items: center;\n  column-gap: 5px;\n  padding: 5px;\n  border-radius: 4px;\n  border: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-primary-row-surface-default);\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.fileItemPicture {\n  width: 42px;\n  height: 29px;\n}\n\n.image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 2px;\n}\n\n.name {\n  font-size: 11px;\n  line-height: 12px;\n  color: var(--tables-primary-row-text-main);\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.extra {\n  font-size: 11px;\n  line-height: 12px;\n  color: var(--tables-primary-row-text-additional);\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"attachedFilesBlock": `attachedFilesBlock__uRfMZ`,
	"attachedFilesTitle": `attachedFilesTitle__T_OfJ`,
	"attachedFiles": `attachedFiles__iwSO2`,
	"fileItem": `fileItem__c21kh`,
	"fileItemPicture": `fileItemPicture__Osspv`,
	"image": `image__bIQH5`,
	"name": `name__Mccdm`,
	"extra": `extra__u_RWd`
};
module.exports = ___CSS_LOADER_EXPORT___;
